import { render, staticRenderFns } from "./SayfaBilgiInfo.vue?vue&type=template&id=1b2d602c&scoped=true"
import script from "./SayfaBilgiInfo.vue?vue&type=script&lang=ts"
export * from "./SayfaBilgiInfo.vue?vue&type=script&lang=ts"
import style0 from "./SayfaBilgiInfo.vue?vue&type=style&index=0&id=1b2d602c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d602c",
  null
  
)

export default component.exports